import EventHandler from "../dom/event-handler";
import { execute } from "../util";
import Swipe from "../util/swipe";

const EVENT_KEY = ".bs.swipe";
const EVENT_POINTERMOVE = `pointermove${EVENT_KEY}`;
const EVENT_POINTERCANCEL = `pointercancel${EVENT_KEY}`;

const SWIPE_THRESHOLD = 40;

const Default = {
	...Swipe.Default,
	vertical: false,
	multiTouch: false,
	startCallback: null,
	topCallback: null,
	bottomCallback: null,
	multiTouchCallback: null,
};

const DefaultType = {
	...Swipe.DefaultType,
	vertical: "boolean",
	multiTouch: "(number|boolean)",
	startCallback: "(function|null)",
	topCallback: "(function|null)",
	bottomCallback: "(function|null)",
	multiTouchCallback: "(function|null)",
};

class ExtendedSwipe extends Swipe {
	constructor(element, config) {
		super(element, config);

		this._deltaY = 0;
		this._multiTouchTriggered = false;
		this._activePointers = {};
		this._customEvents();
	}

	_start(event) {
		if (!this._supportPointerEvents) {
			this._deltaX = event.touches[0].clientX;
			if (this._config.vertical) {
				this._startY = event.touches[0].clientY;
				if (event.touches.length > 1) {
					this._preventDefault(event);
				}
			}
			return;
		}

		if (this._eventIsPointerPenTouch(event)) {
			this._activePointers[event.pointerId] = event;
			this._deltaX = event.clientX;
			if (this._config.vertical) {
				this._startY = event.clientY;
			}
		}

		execute(this._config.startCallback);
	}

	_end(event) {
		if (this._config.vertical) {
			if (this._multiTouchTriggered) {
				this._handleMultitouchSwipe(event);
			} else {
				this._handleVerticalSwipe(event);
			}
		}

		delete this._activePointers[event.pointerId];

		super._end(event);
	}

	_move(event) {
		if (!this._supportPointerEvents) {
			if (this._config.vertical) {
				if (event.touches && event.touches.length > 1) {
					if (event.touches.length > 1) {
						this._deltaY = event.touches[0].clientY - this._startY;
						this._multiTouchTriggered = true;
					} else {
						this._deltaY = 0;
					}
				} else {
					this._deltaY = event.touches[0].clientY - this._startY;
				}
			}

			super._move(event);
		}
		if (this._config.vertical) {
			if (this._eventIsPointerPenTouch(event)) {
				this._deltaY = event.clientY - this._startY;
			} else {
				this._deltaY = 0;
			}
			if (Object.keys(this._activePointers).length > 1) {
				this._multiTouchTriggered = true;
			}
		}
	}

	_handleMultitouchSwipe() {
		const absDeltaY = Math.abs(this._deltaY);

		if (absDeltaY <= SWIPE_THRESHOLD) {
			return;
		}

		const directionY = this._deltaY > 0 ? -1 : 1;

		this._deltaY = 0;

		if (!directionY) {
			return;
		}

		if (directionY < 0) {
			execute(this._config.multiTouchCallback);
		}
	}

	_handleVerticalSwipe() {
		const absDeltaY = Math.abs(this._deltaY);

		if (absDeltaY <= SWIPE_THRESHOLD) {
			return;
		}

		const directionY = this._deltaY > 0 ? -1 : 1;

		this._deltaY = 0;

		if (!directionY) {
			return;
		}

		execute(
			directionY > 0
				? this._config.bottomCallback
				: this._config.topCallback,
		);
	}

	_preventDefault(event) {
		if (event.cancelable) {
			event.preventDefault();
		}
	}

	_customEvents() {
		if (this._supportPointerEvents) {
			EventHandler.on(this._element, EVENT_POINTERMOVE, (event) =>
				this._move(event),
			);
			EventHandler.on(this._element, EVENT_POINTERCANCEL, (event) =>
				this._end(event),
			);
		}
	}

	static get Default() {
		return Default;
	}

	static get DefaultType() {
		return DefaultType;
	}
}

export default ExtendedSwipe;
